import StockExportView from 'src/sections/stock/stock-export/view/stock-export-view';

export default function StockExportPage() {
  return <StockExportView />;
}
